<template>
  <div class="grid grid--widebookmarks">
    <div class="xs-12 m-4 l-3 bookmarks__sidebar">
      <component
        :is="sidebarComponent"
        v-if="showSidebar"
        :show-filters="showFilters"
        :bookmark-types="bookmarkTypes"
        :type-labels="typeLabels"
        :origins="origins"
        @trigger-search="triggerSearch"
      ></component>
      <Buttons
        v-if="!showSidebar"
        class="dea-button--medium dea-button--full dea-button--show-filters"
        @click="showSidebar = true"
      >
        Mostra filtri
      </Buttons>
      <Buttons
        v-if="showSidebar"
        class="dea-button--medium dea-button--full dea-button--hide-filters"
        @click="showSidebar = false"
      >
        Nascondi filtri
      </Buttons>
    </div>
    <div class="xs-12 m-8 l-9 bookmarks__list">
      <header class="bookmarks__header">
        <h2 class="bookmarks__title dea-heading--medium-xxl" tabindex="0">{{ mainTitle }}</h2>
        <InputText
          v-if="resourceObjects.length"
          v-model="filterText"
          class="dea-input--margin-responsive"
          placeholder="Cerca per titolo"
          icon="ricerca"
        />
      </header>
      <p v-if="resourceObjects.length" class="font-family-regular">
        Qui trovi tutte le risorse e materiali didattici che hai aggiunto ai preferiti.
      </p>
      <ResourcesList
        v-if="resourceObjects.length"
        :items="resourcesFiltered"
        card-layout="light"
        :config="config"
        tag1="type_label"
        :use-share-link="true"
        :show-bookmark-origin="true"
        :enable-layout-switch="true"
        :columns="3"
        :accent-modifier="user.targetTitle.toLowerCase()"
        :action-accent-modifier="user.targetTitle.toLowerCase()"
        @save-bookmark="addBookmark"
        @delete-bookmark="removeBookmark"
        @dropdown-toggled="$emit('dropdown-toggled', $event)"
      />
      <EmptyBooks v-else :link-color="user.targetCss.colorMod" :aed="user.aed" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ResourcesList from "@/components/patterns/ResourcesList";
import InputText from "@/components/elements/InputText";
import Buttons from "deascuola-storybook/src/components/elements/Buttons";
import handleWindowResize from "deascuola-storybook/src/components/mixins/handleWindowResize";
import BookmarkActions from "~/components/bookmarks/mixins/BookmarkActions";
import EmptyBooks from "~/components/bookmarks/components/EmptyBooks";
import BookmarkTypeView from "~/components/bookmarks/mixins/BookmarkTypeView";
import setFocus from "~/helpers/setFocus";

export default {
  name: "BookmarksResources",
  components: { ResourcesList, InputText, EmptyBooks, Buttons },
  mixins: [BookmarkActions, handleWindowResize, BookmarkTypeView],
  data() {
    return {
      filterText: "",
      filteredResource: this.resources,
    };
  },
  computed: {
    ...mapGetters(["resourceObjects", "config", "resourcesFiltered"]),
    showFilters() {
      return this.resourceObjects.length > 5;
    },
    origins() {
      const items = this.resourceObjects
        .filter(obj => this.resourcesFiltered.indexOf(obj.payload) > -1)
        .map(item => {
          if (item.data_from)
            return { id: item.data_from.label.toLowerCase().replace(/ /gi, ""), name: item.data_from.label };
          return {};
        });
      // make list unique: they are objects so the must be compared by their string representation
      return Array.from(new Set(items.map(object => JSON.stringify(object)))).map(string => JSON.parse(string));
    },
    typeLabels() {
      const labelsList = this.resourcesFiltered.map(item => {
        return { id: item.type_label, name: item.type_label };
      });
      // make list unique: they are objects so the must be compared by their string representation
      return Array.from(new Set(labelsList.map(object => JSON.stringify(object)))).map(string => JSON.parse(string));
    },
  },
  watch: {
    filterText() {
      this.filterResource({ filterFacet: "title", filterValue: this.filterText });
    },
  },
  mounted() {
    setFocus("bookmarks__title");
  },
  activated() {
    setFocus("bookmarks__title");
  },
  methods: {
    ...mapActions(["filterResource"]),
    triggerSearch(facet, value) {
      this.filterResource({ filterFacet: facet, filterValue: value });
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.bookmarks__list {
  .dea-card-resource-container {
    @include media("<=s") {
      @include hmargin(-$space-xm-small, -$space-xm-small);
    }
  }

  .dea-card-resource__switcher {
    @include media("<=s") {
      @include hmargin($space-xm-small, $space-xm-small);
    }
  }

  .dea-card-resource--compact {
    @include media("<=m") {
      width: 50%;
    }
    @include media("<=sm") {
      width: 100%;
    }

    border: red;
    max-width: unset;
    padding: 0 $space-xm-small;

    width: 33%;
  }
}
</style>
